import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const apiUrl = process.env.REACT_APP_API_BASE_URL;

export const authApiSlice = createApi({
    reducerPath: 'authApi',
    baseQuery: fetchBaseQuery({ baseUrl: apiUrl }),
    endpoints: (builder) => ({
        loginUser: builder.mutation({
            query: (data) => ({
                url: '/user/login',
                method: 'POST',
                body: data,
            }),
        }),
        verifyEmail: builder.mutation({
            query: (data) => ({
                url: '/user/verify-email',
                method: 'POST',
                body: data,
            }),
        }),
        registerUser: builder.mutation({
            query: (data) => ({
                url: `/user/register`,
                method: 'POST',
                body:data,
            }),
        }),
        checkUser: builder.mutation({
            query: (email) => ({
                url: `/user/check-user`,
                method: 'POST',
                body:email,
            }),
        }),
        forgotPwd: builder.mutation({
            query: (data) => ({
                url: `/user/forget-password`,
                method: 'PUT',
                body: data
            }),
        }),
        resetPwd: builder.mutation({
            query: (data) => ({
                url: `/user/reset-password`,
                method: 'PUT',
                body: data
            }),
        }),
        // ------For Vendor registration this route is working-----------------
        vendorRegister: builder.mutation({
            query: (data) => {
                const formData = new FormData();
                for (const key in data) {
                    formData.append(key, data[key]);
                }
        
                return {
                    url: '/admin/register',
                    method: 'POST',
                    body: formData,
                };
            },
        }),
         WholesaleUser: builder.mutation({
            query: (data) => ({
                url: `/admin/wholesale-enquiry`,
                method: 'POST',
                body:data,
            }),
        }),
        ContactForm: builder.mutation({
            query: (data) => ({
                url: `/admin/contact`,
                method: 'POST',
                body:data,
            }),
        }),
//         saveUUID: builder.mutation({
//   query: ({ email, uuid }) => ({
//     url: `/user/age-verification/save`,
//     method: 'POST',
//     body: { email, uuid },
//   }),
// }),
// checkAgeStatus: builder.query({
//   query: (email) => `/user/age-verification/status/${email}`,
// }),
 
    }),
});

export const {
    useLoginUserMutation,
    useVerifyEmailMutation,
    useRegisterUserMutation,
    useForgotPwdMutation,
    useResetPwdMutation,
    useVendorRegisterMutation,
    useWholesaleUserMutation,
    useContactFormMutation,
    useCheckUserMutation,
    useSaveUUIDMutation,
    useCheckAgeStatusQuery
} = authApiSlice;

export const authApiReducer = authApiSlice.reducer;


